import 'store/bolt/showtimesLoader';
import Store from 'store/store';

Store.on('SHOWTIMES_SHOW', (animate, queryString, pageId) => {
	const store = Store.get();
	let returnTo = store.activePage;
	if (pageId && returnTo === pageId) {
		// Landing directly on a showtimes page - assume there is a matching event page
		returnTo = pageId.replace(/-showtimes$/i, '');
	}
	store.showtimes.set({ returnToPage: returnTo });
	Store.emit('SET_HEADER_ACTION', {
		icon: 'close',
		action: () => Store.emit('SHOWTIMES_HIDE', true, true),
		tag: 'closeShowtimesOverlay'
	});
});

Store.on('SHOWTIMES_HIDE', () => {
	Store.emit('REMOVE_HEADER_ACTIONS', 'closeShowtimesOverlay');
});